exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.preview_content_block[data-v-372c4bae] {\n    display: none;\n}\n.image_download_btn[data-v-372c4bae] {\n    margin-top: 15px;\n}\n.image_preview_container[data-v-372c4bae] {\n    margin-top: 25px;\n}\n", ""]);

// exports
